import React from 'react';
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  Paper,
} from '@mui/material';

const RM_fourth = () => {
  return (
    <Box
      sx={{
        width: '95%',
        py: 2,
        display: 'flex',
        gap: 2,
        boxSizing: 'border-box',
      }}
    >
      {/* Data Sources Section */}
      <Box
        sx={{
          flex: 1,
          p: 2,
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          borderRadius: 2,
        }}
      >
        <Typography variant="h6" fontWeight={600} sx={{ color: '#242424' }} >
          360° Company Profiles
        </Typography>

        <Typography variant="body2" mt={1}>
          Our 360° company profiles are built entirely from ethical, unbiased, and publicly available sources, offering a detailed lens into organizational health and market strategy.
        </Typography>

        <Typography variant="subtitle2" fontWeight={600} mt={2}>
          We Extract From:
        </Typography>
        <List dense disablePadding>
          {[
            'Financial filings (SEC EDGAR, MCA, Companies House, SEDAR)',
            'Annual reports, investor presentations, shareholder data',
            'Corporate websites, product catalogs, CSR reports',
            'Patent & compliance databases (WIPO, USPTO, REACH, RoHS)',
            'Global and regional news coverage',
          ].map((text, idx) => (
            <ListItem key={idx} disableGutters>
              <ListItemText primary={`• ${text}`} />
            </ListItem>
          ))}
        </List>
      </Box>

      {/* Profile Contents Section */}
      <Box
        sx={{
          flex: 1,
          p: 2,
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          borderRadius: 2,
        }}
      >
        <Typography variant="subtitle2" fontWeight={600}>
          What Our Profiles Include:
        </Typography>
        <List dense disablePadding sx={{ mt: 1 }}>
          {[
            'Origin, mission, and milestones',
            'Organizational structure and leadership',
            'Financial performance and capital structure',
            'Product/service portfolio and innovation pipeline',
            'Geographic and vertical market presence',
            'SWOT analysis and ESG compliance',
            'Recent developments and strategic moves',
            'Competitive benchmarking and, where applicable, valuation insights',
            'Forecasted revenue streams and market share evolution (for innovation-led firms)',
          ].map((text, idx) => (
            <ListItem key={idx} disableGutters>
              <ListItemText primary={`• ${text}`} />
            </ListItem>
          ))}
        </List>
      </Box>
    </Box>
  );
};

export default RM_fourth;
